import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var DocumentLabelTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(DocumentLabelTransformer, _BaseTransformer);
  var _super = _createSuper(DocumentLabelTransformer);
  function DocumentLabelTransformer() {
    _classCallCheck(this, DocumentLabelTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(DocumentLabelTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        labelName: data.label_name,
        recordOwner: data.record_owner,
        createdOn: data.created_on,
        createdBy: data.created_by,
        lastModifiedOn: data.last_modified_on,
        lastModifiedBy: data.last_modified_by,
        recordId: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return DocumentLabelTransformer;
}(BaseTransformer);